import {
  Chart as ChartJS,
  BarController,
  LineController,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { Chart } from 'react-chartjs-2';

ChartJS.register(
  BarController,
  LineController,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Tooltip,
  Legend
);

/**
 * Stacked bar chart (APPLIED, REJECTED, NO ACTION, TOTAL) with a line overlay (TOTAL REMAINING)
 * on a secondary y-axis (backlog).
 * @param {{ time, applied, rejected, no_action, total, total_remaining }[]} data
 */
function IssuesBarChart({ title, data, loading, error }) {
  if (loading) {
    return (
      <div className="tl-card tl-card--wide">
        <h3 className="tl-card__title">{title}</h3>
        <div className="tl-card__placeholder">Loading…</div>
      </div>
    );
  }
  if (error || !data || data.length === 0) {
    return (
      <div className="tl-card tl-card--wide">
        <h3 className="tl-card__title">{title}</h3>
        <div className="tl-card__placeholder">No data</div>
      </div>
    );
  }

  const labels = data.map((d) => d.time.substring(0, 10));

  const chartData = {
    labels,
    datasets: [
      {
        type: 'bar',
        label: 'APPLIED',
        data: data.map((d) => d.applied),
        backgroundColor: '#4CAF50',
      },
      {
        type: 'bar',
        label: 'REJECTED',
        data: data.map((d) => d.rejected),
        backgroundColor: '#F44336',
      },
      {
        type: 'bar',
        label: 'NO ACTION',
        data: data.map((d) => d.no_action),
        backgroundColor: '#9E9E9E',
      },
      {
        type: 'bar',
        label: 'TOTAL',
        data: data.map((d) => d.total),
        backgroundColor: '#2196F3',
      },
      {
        type: 'line',
        label: 'TOTAL REMAINING',
        data: data.map((d) => d.total_remaining),
        borderColor: '#FF9800',
        backgroundColor: 'transparent',
        tension: 0.2,
        pointRadius: 4,
        yAxisID: 'y1',
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        onClick: (e, legendItem, legend) => {
          const chart = legend.chart;
          const clicked = legendItem.datasetIndex;
          const isOnlyOneVisible = chart.data.datasets.every(
            (_, i) => i === clicked || !chart.isDatasetVisible(i)
          );
          if (isOnlyOneVisible) {
            chart.data.datasets.forEach((_, i) => chart.show(i));
          } else {
            chart.data.datasets.forEach((_, i) => {
              if (i === clicked) chart.show(i);
              else chart.hide(i);
            });
          }
        },
      },
    },
    scales: {
      y: { beginAtZero: true, title: { display: true, text: 'Count' } },
      y1: {
        position: 'right',
        beginAtZero: true,
        title: { display: true, text: 'Backlog' },
        grid: { drawOnChartArea: false },
      },
    },
  };

  return (
    <div className="tl-card tl-card--wide">
      <h3 className="tl-card__title">{title}</h3>
      <div style={{ height: 260 }}>
        <Chart type="bar" data={chartData} options={options} />
      </div>
    </div>
  );
}

export default IssuesBarChart;
